<div matTooltip="{{ toolTipText }}" matTooltipPosition="{{ toolTipPosition }}">
    <i class="{{ iClass }}"></i>
</div>